import { render, staticRenderFns } from "./PasswordRemind.vue?vue&type=template&id=3591a79c&"
import script from "./PasswordRemind.vue?vue&type=script&lang=js&"
export * from "./PasswordRemind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports